import { useEffect, useState } from 'react';
import Icon from '../../components/Icon';
import { useUI } from '../../UIContext';
import { get } from '../../services/api';
import { handleErr, paginationPageSize } from '../../utils/functions';
import { useNavigate } from 'react-router-dom';
import ListPage from '../../components/ListPage';

function Instructors() {
    const amountByPage = paginationPageSize();
    const page = 1;

    const { loading, setLoading, setMessage } = useUI();
    const [instructors, setInstructors] = useState([]);
    const [instructorsFiltered, setInstructorsFiltered] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(amountByPage);
    const [pageTotal, setPageTotal] = useState(0);
    const navigate =  useNavigate();

    function onClickUpdateInstructor(instructorId) {
        navigate(`/instructors/update/${instructorId}`);
    }

    const tableCols = [
        {
            dataIndex: 'fullName',
            title: 'Professor',
            render: (value) => (
                <span>{value}</span>
            )
        },
        {
            title: 'Ações',
            width: '120px',
            render: (_, row) => (
                <button onClick={() => onClickUpdateInstructor(row.id)} className='border-button edit-button glass-button-effect-15'>
                    <Icon iconClass='icon-pencil' size={16} />
                    Editar
                </button>
            )
        }
    ];

    useEffect(() => {
        async function getInstructors() {
            setLoading(true);

            await get('/instructor', true, setMessage,
                (response) => {
                    setInstructors(response.data);
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível carregar os professores: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            )
        }

        getInstructors();
    }, [setLoading, setMessage]);

    useEffect(() => {
        if (!instructors || instructors.length === 0) {
            setInstructorsFiltered([]);
            setPageTotal(0);
            return;
        }

        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;

        const instructorsFound = instructors?.filter(instructor => 
            instructor.name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
            instructor.lastName?.toLowerCase().includes(searchTerm?.toLowerCase())
        );

        setPageTotal(instructorsFound.length);
        setInstructorsFiltered(instructorsFound.slice(startIndex, endIndex));

    }, [searchTerm, page, pageSize, instructors]);

    if (loading)
        return;

    return (
        <ListPage
            title='Gestão de Professores'
            addButtonTitle='Novo professor'
            onClickAddButton={() => navigate('/instructors/create')}
            onChangeSearch={(e) => setSearchTerm(e.target.value)}
            tableCols={tableCols}
            dataFiltered={instructorsFiltered}
            tablePageTotal={pageTotal}
            onChangeTablePage={() => { setPageSize(pageSize + amountByPage) }}
        />
    );
}

export default Instructors;